/* eslint-disable prefer-destructuring */
export const ELOQUA_URL = process.env.ELOQUA_URL;
export const CAMPAIGN_ID_REPVISITS = '7010H000001el5w';
export const MARKETO_CAMPAIGN_ID = `${process.env.MARKETO_CAMPAIGN_ID}` || '7012K000001qP4yQAE';
export const LEAD_SOURCE_REPVISITS = 'RepVisits';
export const PRIVACY_URL = `${process.env.PRIVACY_URL}`;
export default ELOQUA_URL;
